export type KnowledgeBaseViewMode = 'files' | 'graph'

/** Normalized search for `/knowledge-base/$kbId` (omit empty keys from the URL). */
export type KnowledgeBaseKbIdSearch = {
  path?: string
  addFile?: '1'
  /** Recently AI-created file to highlight in the file list. */
  highlight?: string
  view?: KnowledgeBaseViewMode
}

export function parseKnowledgeBaseKbIdSearch(
  search: Record<string, unknown>,
): KnowledgeBaseKbIdSearch {
  const rawPath = typeof search.path === 'string' ? search.path.trim() : ''
  const path = rawPath.length > 0 ? rawPath.replace(/^\/+/, '') : undefined
  const addFile =
    search.addFile === '1' || search.addFile === true ? ('1' as const) : undefined
  const rawHighlight =
    typeof search.highlight === 'string' ? search.highlight.trim() : ''
  const highlight =
    rawHighlight.length > 0 ? rawHighlight.replace(/^\/+/, '') : undefined
  const view =
    search.view === 'graph' ? ('graph' as const) : undefined
  return { path, addFile, highlight, view }
}

/** Search params for `/knowledge-base/$kbId` navigations. */
export function knowledgeBaseKbIdSearch(
  overrides: {
    path?: string
    addFile?: '1'
    highlight?: string
    view?: KnowledgeBaseViewMode
  } = {},
): KnowledgeBaseKbIdSearch {
  const result: KnowledgeBaseKbIdSearch = {}
  const path = overrides.path?.trim().replace(/^\/+/, '')
  if (path) result.path = path
  if (overrides.addFile === '1') result.addFile = '1'
  const highlight = overrides.highlight?.trim().replace(/^\/+/, '')
  if (highlight) result.highlight = highlight
  if (overrides.view === 'graph') result.view = 'graph'
  return result
}
